import { createFileRoute, Link } from "@tanstack/react-router";
import { EMAIL } from "@/lib/contacto";

export const Route = createFileRoute("/reembolsos")({
  component: Reembolsos,
  head: () => ({
    meta: [
      { title: "Cancelaciones y reembolsos | Pyme Visible" },
      {
        name: "description",
        content:
          "En el sitio de Pyme Visible no hay compra ni pago online. Las condiciones de cancelación y reembolso se acuerdan por escrito antes de contratar.",
      },
      { property: "og:title", content: "Cancelaciones y reembolsos | Pyme Visible" },
      {
        property: "og:description",
        content: "Información sobre cancelaciones y reembolsos de los servicios de Pyme Visible.",
      },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "es_CL" },
      { property: "og:url", content: "https://pymevisible.cl/reembolsos" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Cancelaciones y reembolsos | Pyme Visible" },
      {
        name: "twitter:description",
        content: "Cómo se acuerdan cancelaciones y reembolsos con Pyme Visible.",
      },
    ],
    links: [{ rel: "canonical", href: "https://pymevisible.cl/reembolsos" }],
  }),
});

function Reembolsos() {
  return (
    <main id="contenido" lang="es-CL" className="pv-legal-page mx-auto max-w-3xl px-5 py-20">
      <Link to="/" className="text-sm font-medium text-primary underline">
        ← Volver al inicio
      </Link>
      <h1 className="mt-6 text-3xl font-extrabold text-navy sm:text-4xl">
        Información sobre cancelaciones y reembolsos
      </h1>

      <div className="pv-legal-copy mt-8 grid gap-8 leading-relaxed text-muted-foreground">
        <p>Esta información es general y no reemplaza una asesoría legal.</p>

        <section>
          <h2 className="text-xl font-bold text-navy">En este sitio no hay pago online</h2>
          <p className="mt-3">
            En esta web no se realizan compras ni pagos. Solo puedes conocer los servicios y
            solicitar contacto. Las condiciones aplicables a cada servicio o producto se informan y
            se acuerdan por escrito antes de contratar.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-navy">Cambios y devoluciones</h2>
          <p className="mt-3">
            No se aceptan cambios ni devoluciones por gusto, arrepentimiento o cambio de preferencia
            cuando el producto fue entregado conforme a lo solicitado, especialmente si fue
            fabricado o configurado de forma personalizada.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-navy">Fallas, defectos y garantía</h2>
          <p className="mt-3">
            Si el producto presenta una falla, defecto de fabricación o no corresponde a lo
            acordado, debes informarlo idealmente dentro de los 15 días siguientes a la entrega o
            instalación para una revisión ágil. Este aviso temprano no limita la garantía legal
            aplicable ni los derechos que reconoce la normativa chilena.
          </p>
          <p className="mt-3">
            Cuando corresponda una solución por falla o defecto, se evaluará la reparación,
            reposición o devolución del monto pagado conforme a la normativa vigente y a las
            circunstancias del caso. Para gestionar una solicitud deberás presentar el comprobante
            de compra y antecedentes o fotografías que permitan evaluar el problema.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-navy">Productos personalizados</h2>
          <p className="mt-3">
            Los productos fabricados, adaptados o configurados según tus especificaciones no admiten
            cambio ni devolución por preferencias posteriores a la aprobación del diseño, medidas,
            materiales, terminaciones o configuración solicitada. Esto no afecta tus derechos cuando
            exista una falla, defecto o incumplimiento de las características acordadas.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-navy">Canal de consultas</h2>
          <p className="mt-3">
            Puedes escribirnos a{" "}
            <a className="font-medium text-primary underline" href={`mailto:${EMAIL}`}>
              {EMAIL}
            </a>{" "}
            para consultar por una cancelación o un reembolso. Estas condiciones no afectan los
            derechos que la ley reconoce a los consumidores.
          </p>
        </section>
      </div>
    </main>
  );
}
